/* eslint-disable @typescript-eslint/no-explicit-any */
export const pickDefined = <T extends Record<string, any>>(
  obj: T
): Partial<T> => {
  const result: Partial<T> = {};
  for (const [key, value] of Object.entries(obj)) {
    if (
      value !== undefined &&
      value !== null &&
      !(typeof value === "number" && isNaN(value))
    ) {
      (result as any)[key] = value;
    }
  }
  return result;
};
